import { render, staticRenderFns } from "./FormFieldGroup.vue?vue&type=template&id=81d2d850"
import script from "./FormFieldGroup.vue?vue&type=script&lang=js"
export * from "./FormFieldGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports